import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'

/**
 * Runs when the router meta.middleware is 'user-action'
 * @param ctx
 */
export function beforeEnter(
  ctx: MiddlewareContext<App, RootState>) {
  const {store, to: {query = {}}} = ctx

  if(!store || !store.state.userAction) {
    throw new Error('[middleware user-action] need to store')
  }

  store.commit('userAction/update', {
    routeFrom: query?.from,
    routeAction: query?.action,
  })

  return ctx.next()
}
